module.exports = __webpack_public_path__ + "images/5d0e5e9b4247dc3b07502e087f4f2b04-icons.svg";